var _style, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat404({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 490 512",
    width: 490,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 633247-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t\t.s1 { fill: #f40000 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m104 18.4c-19.3-1.3-36 13.2-37.3 32.5l-22.7 332.5c-1.3 19.3 13.2 36 32.5 37.3l252.2 17.2 66.1 55.6c6.4 5.3 16 1.1 16.5-7.1l2.2-42.7h0.2l25.1-367.4c1.3-19.3-13.2-36-32.5-37.3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m362.5 312.1c3 2.6 3.4 7.2 0.6 10.1-15.8 16.6-35 29.8-56.2 38.7-23.5 9.8-48.9 14.1-74.3 12.5-25.4-1.5-50.1-8.9-72.1-21.6-20-11.4-37.4-26.9-51-45.4-2.4-3.2-1.5-7.7 1.8-9.9 3.3-2.2 7.7-1.3 10.1 1.9 12.4 16.6 28.1 30.6 46.2 40.9 20.2 11.6 42.7 18.3 65.9 19.8 23.2 1.4 46.4-2.5 67.8-11.5 19.2-8 36.6-19.9 50.9-34.9 2.8-2.9 7.3-3.2 10.3-0.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat404);
export default __webpack_public_path__ + "static/media/chat404.7bad00a27cd3f848cfb1de9c360fcd15.svg";
export { ForwardRef as ReactComponent };